import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HorarioPage } from '../pages/horario.page';

const HorarioRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/horario' element={<HorarioPage />} />
    </Routes>
  );
};

export { HorarioRoutes };
